import SecondResumeReviewAlertModal from './SecondResumeReviewAlertModal'
export default SecondResumeReviewAlertModal
